import { ColumnDef } from '@tanstack/react-table';
import { PencilSimple, Trash } from '@phosphor-icons/react';
import { DataTableColumnHeader } from '@/components/core';
import { Button } from '@/components/ui-kit/button';
import { CtcLevel } from '../../types/ctc-level.types';

interface CreateCtcLevelTableColumnsProps {
  t: (key: string) => string;
  onEdit: (ctcLevel: CtcLevel) => void;
  onDelete: (ctcLevel: CtcLevel) => void;
  canUpdate?: boolean;
  canDelete?: boolean;
}

export const createCtcLevelTableColumns = ({
  t,
  onEdit,
  onDelete,
  canUpdate = true,
  canDelete = true,
}: CreateCtcLevelTableColumnsProps): ColumnDef<CtcLevel>[] => [
  {
    id: 'Level',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('CTC_LEVEL')} />,
    accessorFn: (row) => row.Level ?? '',
    cell: ({ row }) => <span className="truncate font-medium">{row.original.Level}</span>,
  },
  {
    id: 'CTC',
    meta: { filter: { type: 'number' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('CTC_AMOUNT')} />,
    accessorFn: (row) => row.CTC ?? 0,
    cell: ({ row }) => <span>{row.original.CTC?.toLocaleString() ?? ''}</span>,
  },
  {
    id: 'Ranks',
    meta: { filter: { type: 'text' } },
    header: ({ column }) => <DataTableColumnHeader column={column} title={t('CTC_RANKS')} />,
    accessorFn: (row) => row.Ranks ?? '',
    cell: ({ row }) => <span className="truncate">{row.original.Ranks}</span>,
  },
  ...(canUpdate || canDelete
    ? [
        {
          id: 'actions',
          // Card: top right, as the old portal's card header.
          meta: { mobile: 'badge' as const },
          header: () => <span className="text-xs font-medium">{t('ACTION')}</span>,
          enableSorting: false,
          enableHiding: false,
          cell: ({ row }: { row: { original: CtcLevel } }) => (
            <div className="flex items-center gap-1">
              {canUpdate && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onEdit(row.original)}
                  aria-label={t('EDIT')}
                >
                  <PencilSimple className="size-4" />
                </Button>
              )}
              {canDelete && (
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => onDelete(row.original)}
                  aria-label={t('DELETE')}
                >
                  <Trash className="size-4" />
                </Button>
              )}
            </div>
          ),
        },
      ]
    : []),
];
